import { createChatBotMessage } from "react-chatbot-kit";



class ActionProvider {
  constructor(createChatBotMessage, setStateFunc) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
  }
  handleHello() {
    const message = createChatBotMessage("Hello. Nice to meet you.");
    this.addMessageToState(message);
  }
  handleHowAreYou() {
    const message = createChatBotMessage(" Thanks for asking. I’m doing well ");
    this.addMessageToState(message);
  }
  handleSkills() {
    const message = createChatBotMessage("Redirecting to skiils section ....");
    this.addMessageToState(message);
  }
  handleEdu() {
    const message = createChatBotMessage("Prof.Ram Meghe Institute of Technology & Research (2019-2023) B.Tech in Computer Science and Engineering");
    this.addMessageToState(message);
  }
  handleExp() {
    const message = createChatBotMessage("Internship Exprience - Mobile Developer Internat Blue Berry e-Services Pvt. Ltd.");
    this.addMessageToState(message);
  }
  handleGali() {
    const message = createChatBotMessage("Aand Mat Chaba");
    this.addMessageToState(message);
  }

  addMessageToState = (message) => {
    this.setState((prevState) => ({
      ...prevState,
      messages: [...prevState.messages, message],
    }));
  };
}

export default ActionProvider;
